<template>
  <v-app-bar id="app-bar" elevation="4">
    <v-list-item class="text-light-blue" style="padding-top: 24px">
      <v-list-item-content>
        <v-list-item-title class="text-h6" color="info">GPS AIS</v-list-item-title>
        <v-list-item-subtitle class="text-grey-darken-1">
          {{ user?.username }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-btn to="/" color="info">Map</v-btn>
    <v-btn to="/listIncidents" color="info">Incidents</v-btn>
    <v-btn to="/subscription" color="info">Subscription</v-btn>
    <v-btn to="/graph" color="info">Graph</v-btn>
    <v-btn v-if="isAdmin" to="/exclusion" color="info">Exclusion Area</v-btn>

    <v-spacer></v-spacer>

    <div class="nav-right">
      <v-btn
          icon
          color="info"
          class="sound-toggle-btn"
          :title="soundEnabled ? 'Turn off sound' : 'Turn on sound'"
          @click="toggleSound"
      >
        <v-icon v-if="soundEnabled">mdi-volume-high</v-icon>
        <v-icon v-else>mdi-volume-off</v-icon>
      </v-btn>

      <SignOut class="sign-out-wrapper" />
    </div>
  </v-app-bar>
</template>


<script>
import { Auth } from "aws-amplify";
import SignOut from "@/components/SignOut";
import { EventBus } from "@/utils/eventBus";

export default {
  name: "NavigationComponent",
  components: { SignOut },
  data() {
    return {
      user: null,
      isAdmin: false,
      soundEnabled: false
    };
  },
  methods: {
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      EventBus.emit("toggle-sound", this.soundEnabled);
      localStorage.setItem("soundEnabled", this.soundEnabled ? "true" : "false");
    },
  },
  async mounted() {
    try {
      // currentUserInfo() doesn't include token claims like groups — use currentAuthenticatedUser()
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      this.user = { username: user.username, ...user.attributes };

      const groups =
          user.signInUserSession?.idToken?.payload?.["cognito:groups"] || [];
      this.isAdmin = groups.includes("admin");
    } catch (e) {
      console.error("Failed to load user:", e);
      this.user = { username: "Guest" };
      this.isAdmin = false;
    }
    EventBus.emit("toggle-sound", this.soundEnabled);
  },
};
</script>
<style>
#app-bar .nav-right {
  display: flex;
  align-items: center;
  padding-right: 16px;
}

#app-bar .sound-toggle-btn {
  margin-right: 8px;
  min-width: 40px;
}

#app-bar .sign-out-wrapper {
  position: static !important;
}

#app-bar .sign-out-wrapper .v-btn {
  position: static !important;
  margin-left: 0;
}
</style>
